import SimpleBar from 'simplebar';

class CustomScroll {
	constructor(container) {
		// this.init(container);
	}

	init(container) {
		new SimpleBar(container, {
			autoHide: false,
		});
	}
}

document
	.querySelectorAll('.bx_filter_parameters_box_container .filter-section__list, .menu__list-wrapper, .menu__section')
	.forEach((el) => new CustomScroll(el));

export default CustomScroll;
